import { TextField } from "@mui/material";
import { StringFormFieldProps } from "../types";
import { memo, useState, useEffect, useMemo } from "react";
import debounce from "lodash/debounce";

/* 
  Component uses a debouncer to only call onChange after debouncing to avoid slow re-rendering
*/

const StringFormField = memo(({ name, label, disabled = false, required, props }: StringFormFieldProps) => {
  const { onChange, value, ...textFieldProps } = props;

  const [localValue, setLocalValue] = useState(value ?? "");

  // Debounced function to call the parent's onChange handler
  const debouncedOnChange = useMemo(
    () =>
      debounce((event) => {
        onChange(event);
      }, 300),
    [onChange],
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setLocalValue(newValue); // Update local state immediately
    debouncedOnChange(e); // Trigger the parent's onChange after debounce
  };

  // Sync local state with the parent value when the parent changes
  useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value ?? "");
    }
  }, [value]);

  return <TextField fullWidth id={name} name={name} disabled={disabled} label={label} required={required} value={localValue} onChange={handleChange} {...textFieldProps} />;
});

export default StringFormField;
